import { Avatar, CardHeader, Typography } from '@material-ui/core'
import React from 'react'

export interface CardTopProps {
  avatarIcon?: JSX.Element
  title: string | undefined
  subtitle?: string
  titleVariant?: 'primary' | 'secondary'
  action?: React.ReactNode
}

export const CardTop: React.FC<CardTopProps> = ({
  avatarIcon,
  title,
  subtitle,
  titleVariant = 'secondary',
  action
}) => {
  return (
    <CardHeader
      avatar={avatarIcon && <Avatar>{avatarIcon}</Avatar>}
      title={
        <Typography
          variant={titleVariant === 'primary' ? 'h1' : 'h2'}
          color={titleVariant === 'primary' ? 'primary' : 'secondary'}
        >
          {title}
        </Typography>
      }
      subheader={
        <Typography variant={'h6'} color={'secondary'}>
          {subtitle}
        </Typography>
      }
      action={action}
    ></CardHeader>
  )
}
